"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SendResumeFields = void 0;
var SendResumeFields_1 = require("./SendResumeFields");
Object.defineProperty(exports, "SendResumeFields", { enumerable: true, get: function () { return SendResumeFields_1.SendResumeFields; } });
